export default {
  getCompra(state) {
    return state.compra;
  },
  getCompraId(state) {
    return state.compra.id;
  },
};
